module.exports = __webpack_public_path__ + "static/img/banner.6cec5b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/contactus/banner.png
// module id = ydkg
// module chunks = 1